const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNyAyQzE4LjEwNDYgMiAxOSAyLjg5NTQzIDE5IDRWNUgxN1Y0SDdWMTkuMzgyTDEyIDE2Ljg4MkwxNyAxOS4zODJWMTdIMTlWMjIuNjE4TDEyIDE5LjExOEw1IDIyLjYxOFY0QzUgMi44OTU0MyA1Ljg5NTQzIDIgNyAySDE3Wk0yMCA4VjEwSDIyVjEySDIwVjE0SDE4VjEySDE2VjEwSDE4VjhIMjBaIi8+Cjwvc3ZnPgo=";
export {
  I as default
};
//# sourceMappingURL=bookmark-5c097db0.mjs.map
